<template>
  <el-dialog
    title="注意"
    :visible.sync="dialogVisible"
    width="470px"
    >
    <div style="text-align: justify;">
      当前需添加的分销商品，部份spu或sku编码已存在<el-link style="margin-top: -4px;" @click="lookRepeatClick">查看明细</el-link>，若要继续添加到分销商品，将在spu编码后加上SCM-XXXXX(随机)，如AK28-SCM-yyds1；在sku编码后加3位随机数后缀，如AK28sku123。
      <div>点击“确定”添加，“取消”则放弃添加</div>
      <div class="ftsz12 text-orange mgt20">
        注意：若同款下的sku编码存在重复（铺货支持sku编码重复），可能影响到后续ERP分销订单发货，为此您可以手动编辑修改sku编码防止发货异常
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSure">确 定</el-button>
    </span>
    <RepeatOuterId
      :visible.sync="repeatVisible"
      :oldItem="res.oldItem"
      :addItem="res.addItem"
      />
</el-dialog>
</template>

<script>
import RepeatOuterId from './repeatOuterId.vue'
export default {
  components: {
    RepeatOuterId
  },
  data() {
    return {
      repeatVisible: false,
      dialogVisible: false,
      params: {},
      res: {},
      row:{},
      type:''
    }
  },
  methods: {
    method_open(params, res = {}, row, type) {
      this.dialogVisible = true;
      this.params = params;
      this.res = res;
      this.row = row;
      this.type = type;
    },
    handleSure() {
      this.dialogVisible = false;
      if(this.type === 'shelves'){
        this.$emit('join', this.params, 'singleJoinGoods', this.row, this.type);
      }else{
        this.$emit('join', this.params);
      }
      
    },
    lookRepeatClick() {
      if (!this.res.oldItem || !this.res.oldItem.length) {
        return this.$message.error(`无明细查看：${this.res.repeatMessage || '-'}`)
      }
      this.repeatVisible = true;
    }
  }

}
</script>

<style lang="scss" scoped>

</style>
